import equals from 'fast-deep-equal';

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function F() {
  return false;
}

function identity(x) {
  return x;
}

function _reduce(halt, fn, y, xs) {
  var result = y;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = xs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var x = _step.value;

      if (halt(result)) {
        return result;
      }

      result = fn(result, x);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return result;
}
function any(fn, xs) {
  return _reduce(identity, function (_, x) {
    return fn(x);
  }, false, xs);
}
function map(fn, xs) {
  return reduce(function (ys, x) {
    return ys.concat([fn(x)]);
  }, [], xs);
}
function reduce(fn, y, xs) {
  return _reduce(F, fn, y, xs);
}
function get(fallback, path, obj) {
  return _reduce(function (result) {
    return result == null;
  }, function (result, key) {
    if (fallback instanceof Error) {
      if (!result.hasOwnProperty(key)) {
        throw fallback;
      }
    }

    return result.hasOwnProperty(key) ? result[key] : fallback;
  }, obj, path);
}
function reject(fn, xs) {
  return reduce(function (ys, x) {
    return fn(x) ? ys : ys.concat([x]);
  }, [], xs);
}
function isEmptyArray(xs) {
  return xs.length === 0;
}
function unnest(xs) {
  return reduce(function (ys, x) {
    return ys.concat(Array.isArray(x) ? x : [x]);
  }, [], xs);
}

function exclusiveMaximum(reference, data) {
  if (reference == null) {
    return true;
  }

  return data < reference;
}
function exclusiveMinimum(reference, data) {
  if (reference == null) {
    return true;
  }

  return data > reference;
}
function maximum(reference, data) {
  if (reference == null) {
    return true;
  }

  return data <= reference;
}
function minimum(reference, data) {
  if (reference == null) {
    return true;
  }

  return data >= reference;
}
function multipleOf(reference, data) {
  if (reference == null) {
    return true;
  }

  return data % reference === 0;
}
function maxLength(reference, data) {
  if (reference == null) {
    return true;
  }

  return data.length <= reference;
}
function maxProperties(reference, data) {
  return maxLength(reference, Object.keys(data));
}
function minLength(reference, data) {
  if (reference == null) {
    return true;
  }

  return data.length >= reference;
}
function minProperties(reference, data) {
  return minLength(reference, Object.keys(data));
}
function pattern(reference, data) {
  if (reference == null) {
    return true;
  }

  var re = new RegExp(reference);
  return re.test(data);
}
function type(reference, data) {
  if (reference == null) {
    return true;
  }

  switch (reference) {
    case 'null':
      {
        return data === null;
      }

    case 'boolean':
    case 'number':
    case 'string':
      {
        return _typeof(data) === reference;
      }

    case 'integer':
      {
        return parseInt(data, 10) === data;
      }

    case 'array':
      {
        return Array.isArray(data);
      }

    case 'object':
      {
        return data != null && _typeof(data) === 'object' && Array.isArray(data) === false;
      }

    default:
      {
        throw new Error("Unknown type \"".concat(reference, "\""));
      }
  }
}
function uniqueItems(reference, data) {
  if (reference == null) {
    return true;
  }

  if (reference) {
    for (var i = data.length - 1; i >= 0; i--) {
      var index = data.indexOf(data[i]);

      if (index > -1 && index < i) {
        return false;
      }
    }
  }

  return true;
}
function values(reference, data) {
  if (reference == null) {
    return true;
  }

  return any(function (x) {
    return equals(data, x);
  }, reference);
}
function value(reference, data) {
  if (reference == null) {
    return true;
  }

  return values([reference], data);
}

var checks = /*#__PURE__*/Object.freeze({
  exclusiveMaximum: exclusiveMaximum,
  exclusiveMinimum: exclusiveMinimum,
  maximum: maximum,
  minimum: minimum,
  multipleOf: multipleOf,
  maxLength: maxLength,
  maxProperties: maxProperties,
  minLength: minLength,
  minProperties: minProperties,
  pattern: pattern,
  type: type,
  uniqueItems: uniqueItems,
  values: values,
  value: value
});

var MissingRefError =
/*#__PURE__*/
function (_Error) {
  _inherits(MissingRefError, _Error);

  function MissingRefError(message) {
    var _this;

    _classCallCheck(this, MissingRefError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MissingRefError).call(this, message));
    _this.name = 'MissingRefError';
    return _this;
  }

  return MissingRefError;
}(_wrapNativeSuper(Error));

var VALIDATORS_MAPPING = {
  "const": 'value',
  "enum": 'values',
  maxItems: 'maxLength',
  minItems: 'minLength'
  /**
   * Validate JSON instance using given JSON schema
   * @param {Array.<string>} absoluteInstancePath
   * @param {Array.<string>} absoluteSchemaPath
   * @param {*} instance
   * @param {Object.<string, *>} schema
   * @param {function(ValidationError): undefined} onError
   * @returns {undefined}
   */

};

function validate(absoluteInstancePath, absoluteSchemaPath, instance, schema, onError) {
  function createError(validator, validatorValue, context) {
    return {
      absoluteInstancePath: absoluteInstancePath,
      absoluteSchemaPath: absoluteSchemaPath.concat([validator]),
      context: context,
      validator: validator,
      validatorValue: validatorValue
    };
  }

  if (schema == null) {
    return null;
  }

  var schemaSlice = get(undefined, absoluteSchemaPath, schema);

  if (schemaSlice == null) {
    return null;
  }

  if (typeof schemaSlice.$ref === 'string') {
    var absoluteRefPath = schemaSlice.$ref.split('/').slice(1);
    get(new MissingRefError("\"".concat(schemaSlice.$ref, "\" is missing in root schema")), absoluteRefPath, schema);
    return validate(absoluteInstancePath, absoluteRefPath, instance, schema, onError);
  }

  var instanceSlice = get(undefined, absoluteInstancePath, instance);

  for (var validator in schemaSlice) {
    var validatorValue = schemaSlice[validator];

    switch (validator) {
      case 'additionalItems':
        {
          if (Array.isArray(schemaSlice.items)) {
            var start = schemaSlice.items.length;
            var end = instanceSlice.length;

            for (var index = start; index < end; index++) {
              validate(absoluteInstancePath.concat([index]), absoluteSchemaPath.concat([validator, index]), instance, schema, onError);
            }
          }

          break;
        }

      case 'additionalProperties':
        {
          var instanceProperties = Object.keys(instanceSlice);
          var properties = get({}, ['properties'], schemaSlice);
          var patterns = map(function (pattern) {
            return new RegExp(pattern);
          }, Object.keys(get({}, ['patternProperties'], schemaSlice)));

          var _loop = function _loop() {
            var key = _instanceProperties[_i];

            if (!properties.hasOwnProperty(key) && !any(function (re) {
              return re.test(key);
            }, patterns)) {
              validate(absoluteInstancePath.concat([key]), absoluteSchemaPath.concat([validator]), instance, schema, onError);
            }
          };

          for (var _i = 0, _instanceProperties = instanceProperties; _i < _instanceProperties.length; _i++) {
            _loop();
          }

          break;
        }

      case 'allOf':
      case 'anyOf':
      case 'oneOf':
        {
          if (Array.isArray(validatorValue)) {
            var validations = [];

            var _loop2 = function _loop2(_index) {
              var errors = [];
              validate(absoluteInstancePath, absoluteSchemaPath.concat([validator, _index]), instance, schema, function (error) {
                return errors.push(error);
              });
              validations.push(errors);
            };

            for (var _index in validatorValue) {
              _loop2(_index);
            }

            var failedCount = reject(isEmptyArray, validations).length;
            var passedCount = validatorValue.length - failedCount;

            if (validator === 'allOf' && failedCount > 0 || validator === 'anyOf' && passedCount < 1 || validator === 'oneOf' && passedCount !== 1) {
              onError(createError(validator, validatorValue, unnest(validations)));
            }
          }

          break;
        }

      case 'contains':
        {
          var _ret = function () {
            var context = [];

            var _loop3 = function _loop3(_index2) {
              var errors = [];
              validate(absoluteInstancePath.concat([_index2]), absoluteSchemaPath.concat([validator]), instance, schema, function (error) {
                context.push(error);
                errors.push(error);
              }); // Stop and succeed if any instance item passes validation

              if (errors.length === 0) {
                context.length = 0;
                return "break";
              }
            };

            for (var _index2 in instanceSlice) {
              var _ret2 = _loop3(_index2);

              if (_ret2 === "break") break;
            }

            if (instanceSlice.length === 0 || context.length) {
              onError(createError(validator, validatorValue, context));
            }

            return "break";
          }();

          if (_ret === "break") break;
        }

      case 'dependencies':
        {
          for (var dependency in validatorValue) {
            if (instanceSlice.hasOwnProperty(dependency)) {
              if (Array.isArray(validatorValue[dependency])) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                  for (var _iterator = validatorValue[dependency][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var property = _step.value;

                    if (!instanceSlice.hasOwnProperty(property)) {
                      onError(createError(validator, validatorValue));
                    }
                  }
                } catch (err) {
                  _didIteratorError = true;
                  _iteratorError = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                      _iterator["return"]();
                    }
                  } finally {
                    if (_didIteratorError) {
                      throw _iteratorError;
                    }
                  }
                }
              } else {
                validate(absoluteInstancePath, absoluteSchemaPath.concat([validator, dependency]), instance, schema, onError);
              }
            }
          }

          break;
        }

      case 'if':
        {
          var valid = true;
          validate(absoluteInstancePath, absoluteSchemaPath.concat(['if']), instance, schema, function () {
            valid = false;
          });
          var conditionalValidator = valid ? 'then' : 'else';
          validate(absoluteInstancePath, absoluteSchemaPath.concat([conditionalValidator]), instance, schema, onError);
          break;
        }

      case 'items':
        {
          if (Array.isArray(schemaSlice.items)) {
            for (var _index3 in validatorValue) {
              validate(absoluteInstancePath.concat([_index3]), absoluteSchemaPath.concat([validator, _index3]), instance, schema, onError);
            }
          } else {
            for (var _index4 in instanceSlice) {
              validate(absoluteInstancePath.concat([_index4]), absoluteSchemaPath.concat([validator]), instance, schema, onError);
            }
          }

          break;
        }

      case 'not':
        {
          var _validateSchema = validateSchema(validatorValue, instanceSlice),
              _valid = _validateSchema.valid;

          if (_valid) {
            onError(createError(validator, validatorValue));
          }

          break;
        }

      case 'patternProperties':
        {
          var _loop4 = function _loop4(pattern) {
            var re = new RegExp(pattern);
            var properties = Object.keys(instanceSlice).filter(function (key) {
              return re.test(key);
            });
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = properties[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var key = _step2.value;
                validate(absoluteInstancePath.concat([key]), absoluteSchemaPath.concat([validator, pattern]), instance, schema, onError);
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                  _iterator2["return"]();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          };

          for (var pattern in validatorValue) {
            _loop4(pattern);
          }

          break;
        }

      case 'properties':
        {
          for (var key in instanceSlice) {
            validate(absoluteInstancePath.concat([key]), absoluteSchemaPath.concat([validator, key]), instance, schema, onError);
          }

          break;
        }

      case 'required':
        {
          var context = [];
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = validatorValue[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var _key = _step3.value;

              if (instanceSlice == null || !instanceSlice.hasOwnProperty(_key)) {
                context.push({
                  absoluteInstancePath: absoluteInstancePath.concat([_key]),
                  absoluteSchemaPath: absoluteSchemaPath.concat([validator]),
                  validator: validator,
                  validatorValue: validatorValue
                });
              }
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
                _iterator3["return"]();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }

          if (context.length > 0) {
            onError(createError(validator, validatorValue, context));
          }

          break;
        }

      default:
        {
          var check = VALIDATORS_MAPPING[validator] || validator;
          var fn = checks[check];

          if (fn && !fn(validatorValue, instanceSlice)) {
            onError(createError(validator, validatorValue));
          }

          break;
        }
    }
  }
}

function validateSchema(schema, instance) {
  var errors = [];
  validate([], [], instance, schema, function (error) {
    return errors.push(error);
  });
  return {
    valid: errors.length === 0,
    errors: errors
  };
}

export default validateSchema;
//# sourceMappingURL=index.es.js.map
